import { Component, ViewChild, ElementRef, AfterViewInit,Input, EventEmitter } from '@angular/core';
import { NcalayerService } from '../../@core/utils/ncalayer/ncalayer.service';
import { Cell, DefaultEditor, Editor } from 'ng2-smart-table';
import { Subscription } from 'rxjs';

@Component({
  template: `
  <input [ngClass]="inputClass"
        #name
        [value]="Name"
        [(ngModel)]="Name"
        class="form-control short-input"
        (change)="selected($event.target.value)"
        (input)="this.inputName($event.target.value)"
        [name]="cell.getId()"
        [disabled]="true"
        [placeholder]="cell.getTitle()"
        (click)="onClickIDN($event)"
        (keyup)="updateValue()"
        (keydown.enter)="onEdited2($event)"
        (keydown.esc)="onStopEditing.emit()"
        >         
       <div [hidden]="true" [innerHTML]="cell.getValue()" #htmlValue></div>
      
  `,
})
export class CustomEditorComponent3 extends DefaultEditor implements AfterViewInit {
 
  @Input() valueChange :EventEmitter<string> = new EventEmitter();
  @ViewChild('name') name: ElementRef;
  @ViewChild('url') url: ElementRef;
  @ViewChild('htmlValue') htmlValue: ElementRef;
   Name:string;
   personsN:any []; 
   selectedPersons:never[];
   subscription:Subscription;
  constructor( public ncalayer: NcalayerService,) {
    
    super();
  }
  ngAfterViewInit() {
    this.personsN = JSON.parse(sessionStorage.getItem("persons"));
 
    this.cell.newValue = this.name.nativeElement.value
    if (this.cell.newValue !== '') {
      this.name.nativeElement.value = this.getUrlName();
        this.cell.newValue = this.name.nativeElement.value
    }
    this.subscription = this.ncalayer.getChangeIDN().subscribe((data: string) => {
      for (let i=0; i<this.personsN.length; i++){
          if (data===this.personsN[i].IDN){
            this.name.nativeElement.value= this.personsN[i].FM;
            this.cell.newValue =this.name.nativeElement.value;

          }
      }
     });
  }
  ngOnDestroy(){
    this.subscription.unsubscribe();
  }
  inputName(str:string){
    this.name.nativeElement.value= str;
    this.cell.newValue =this.name.nativeElement.value;
  }
  getUrlName(): string {
    return this.htmlValue.nativeElement.innerText;
  }
  onClickIDN(event:any){
    
  }
  onEdited2(event:any){

  }
  onInput(val: string) {
    this.valueChange.emit(val);

    this.updateValue()
  }
  
  updateValue() {
   // const href = this.url.nativeElement.value;
    const name = this.name.nativeElement.value;
    this.cell.newValue = name;
  }
  selected(arg:any){   
    this.valueChange.emit(arg);
  }

}
